import React, {useState, useEffect, Fragment} from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  FormText
} from 'reactstrap';
import Button from '../Button/Button';
import InputCell from '../InputCell/InputCell'
import {useErrorToast} from '../../hooks/useErrorToast';
import {useFormValidation} from '../../hooks/useFormValidation';
import SourceOfFundsDataStore from '../../stacks/sourceOfFunds/sourceOfFundsAWS';

const SourceOfFundsModificationScreen = props => {

  const clearForm = {
    companyName: '',
    companyAddress1: '',
    companyAddress2: '',
    companyCity: '',
    companyState: '',
    companyZip: '',
    companyPhone1: '',
    companyURL: '',
    companyContactName: '',
    companyContactPhone: '',
    companyContactEmail: '',
  }

  const [form,setForm] = useState(clearForm)
  const [isDirty, setIsDirty] = useState(false)

  const {setErrorMsg,errorToast} = useErrorToast('');
  const {validated,setValidated,checkValidation} = useFormValidation(form,[
    'companyName',
    'companyAddress1',
    'companyCity',
    'companyState',
    'companyZip',
    'companyContactName',
    'companyContactPhone',
    'companyContactEmail'
  ]);

  const controlled = {
    form,
    setForm,
    validated,
    setIsDirty
  }

  useEffect(() => {
    async function retrieve() {
      try {
        const sofAPI = SourceOfFundsDataStore.getInstance();
        const data = await sofAPI.retrieveSof()
        setForm({...clearForm, ...data})
      }
      catch(err) {
        setErrorMsg(`retrieve error: ${err.code} ${err.message}`);
        console.error(`retrieve error: ${err.code} ${err.message}`);
      }
    }
    retrieve()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function store() {
    try {
      let isValid = checkValidation();
      setValidated(isValid);
      if (isValid) {
        let company = {}
        for (const key in form) {
          if (key.startsWith('company')) {
            company[key] = form[key]
          }
        }
        const sofAPI = SourceOfFundsDataStore.getInstance();
        await sofAPI.storeSof(company)
        setIsDirty(false)
      }
    }
    catch(err) {
      setErrorMsg(`Store error: ${JSON.stringify(err.message,null,2)}`);
      console.error(`Store error: ${JSON.stringify(err.message,null,2)}`);
    }
  }

  return (
    <Fragment>
      <Container>
          <Row>
            <Col>
              <FormText>* <i>required field</i> </FormText>
            </Col>
          </Row>
          <div style={{height:'40px'}} />
          <Form>
            <Row form>
              <Col>
                <InputCell
                  controlled={controlled}
                  label='Company name as registered, without punctuation and without "LLC", etc.*'
                  name='companyName'
                  validate
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputCell
                  controlled={controlled}
                  label='Company Address line 1*'
                  name='companyAddress1'
                  validate
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputCell
                  controlled={controlled}
                  label='Company Address line 2'
                  name='companyAddress2'
                />
              </Col>
            </Row>
            <Row form>
              <Col md={6}>
                <InputCell
                  controlled={controlled}
                  label='City*'
                  name='companyCity'
                  validate
                />
              </Col>
              <Col md={4}>
                <InputCell
                  controlled={controlled}
                  label='State*'
                  name='companyState'
                  state
                  validate
                />
              </Col>
              <Col md={2}>
                <InputCell
                  controlled={controlled}
                  label='Zip*'
                  name='companyZip'
                  validate
                />
              </Col>
            </Row>
            <Row form>
              <Col md={6}>
                <InputCell
                  controlled={controlled}
                  label='Company Phone'
                  name='companyPhone1'
                />
              </Col>
              <Col md={6}>
                <InputCell
                  controlled={controlled}
                  label='Company URL'
                  name='companyURL'
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                  <InputCell
                    controlled={controlled}
                    label='Company Contact Name*'
                    name='companyContactName'
                    validate
                    />
                </Col>
                <Col md={4}>
                  <InputCell
                    controlled={controlled}
                    label='Company Contact Phone*'
                    name='companyContactPhone'
                    validate
                    />
              </Col>
              <Col md={4}>
                  <InputCell
                    controlled={controlled}
                    label='Company Contact Email*'
                    name='companyContactEmail'
                    validate
                    />
              </Col>
            </Row>
            <hr style={{marginTop:'40px'}} />
            <div style={{textAlign:'right'}}>
              {!validated &&
                <span style={{color: 'red', verticalAlign: 'center'}}>
                  Please correct red outlined fields&nbsp;
                </span>
              }
              {isDirty && <Button click={ () => { store(false) } }>UPDATE</Button>}
            </div>
          </Form>
        <div style={{height:60}} />
      </Container>
      {errorToast}
    </Fragment>

  );
};

export default SourceOfFundsModificationScreen;
